import { Component, Inject, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GtwSnackbarService } from '../../../../shared/_services/gtw-snackbar.service';
import { GlobalService } from '../../../../global/services/global.service';
import { AppService } from '../../../../app.service';
import { ClientLandingPageService } from '../client-landing-page.service';
import { environment } from '../../../../../environments/environment';
import * as _ from 'lodash-es';

export interface ClientDetailsDialogData {
  client: any;
  clientLanDtls: any[];
}

@Component({
    selector: 'gtw-client-details-modal',
    templateUrl: './client-details-modal.component.html',
    styleUrls: ['./client-details-modal.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClientDetailsModalComponent {
  private readonly destroyRef = inject(DestroyRef);


  client: any;
  clientLanDtls: any[];
  crudLoading = '';
  minimise = false;

  constructor(
    public dialogRef: MatDialogRef<ClientDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ClientDetailsDialogData,
    private globalService: GlobalService,
    private appService: AppService,
    private clientLandingService: ClientLandingPageService,
    private gtwSnackbarService: GtwSnackbarService,
    private router: Router
  ) {
    this.client = data.client;
    this.clientLanDtls = data.clientLanDtls;
  }

  get contactInitials(): string {
    const name: string = this.client?.ENGAGMNT_CONTACT_PERSON || '';
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return parts[0]?.[0]?.toUpperCase() || '?';
  }

  launchClient(clientKey: string, route: string, stateLink: string, buttonId: string): void {
    this.crudLoading = buttonId;

    this.globalService.setClient(clientKey, environment.base_url).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (res: any) => {
        if (res?.callSuccess == '1') {
          const newKey = res.switch_to_client_key?.toString() || clientKey.toString();
          sessionStorage.setItem('client_key', newKey);
          this.dialogRef.close({ action: 'launched' });
          this.clientLandingService.landingPage(route, this.appService, this.router);
        } else {
          this.crudLoading = '';
          const failedName = this.resolveFailedClientName(res);
          this.gtwSnackbarService.openSnackBar(
            `Unable to change the client: ${failedName}! Please Check Assigned: Workspaces OR Scenarios OR Modules etc.`,
            'gtw-snackbar--red'
          );
        }
      },
      () => {
        this.crudLoading = '';
        this.gtwSnackbarService.openSnackBar(
          'Failed to switch client. Please try again.',
          'gtw-snackbar--red'
        );
      }
    );
  }

  private resolveFailedClientName(res: any): string {
    const switchKey = res?.switch_to_client_key;
    if (switchKey !== undefined && switchKey !== null && switchKey !== '') {
      const matched = _.find(this.clientLanDtls, (c: any) =>
        String(c.CLIENT_KEY) === String(switchKey)
      );
      if (matched?.CLIENT_NAME) {
        return matched.CLIENT_NAME;
      }
    }
    return this.client?.CLIENT_NAME || '';
  }

  cancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }
}
